import { Component, output } from '@angular/core';
import { ModalCloseDirective } from '@shared/ui/modals';

@Component({
  selector: 'shared-ui-modal-loader',
  templateUrl: './modal-loader.component.html',
  styleUrls: ['./modal-loader.component.css'],
  imports: [ModalCloseDirective],
})
export class ModalLoaderComponent {
  closed = output();

  rowsCount = Array.from({ length: 3 }, (_, index) => index);
}
